<template>
<div>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <!-- <v-card-title>
     Procurement Order List
    </v-card-title> -->
    <v-card-title>
      
        <v-btn
              color="primary"
              dark
              class="ma-2"
              @click="addData"
              v-if="role.create"
            >
              Add Daily Closing
            </v-btn>
        <v-menu>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            class="ma-2"
            v-bind="attrs"
            v-on="on"
          >
            Export To XLS
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('all')}"
                    
                  >
                    All Record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :data="exportDisplayedPage"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                  >
                    Displayed record
             </downloadExcel>
          </v-list-item>
          <v-list-item>
            <downloadExcel
                    class = "btn"
                    :fields="field_export"
                    :worksheet="worksheetName"
                    :name="fileName"
                    :fetch= "()=>{return dataExportBefore('filter')}"
                  >
                    All filtered record
                  </downloadExcel>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <div class="d-flex">
        <v-select
        style=" max-width: 150px;"
          :items="option_filter"
          label="Select"
          v-model="searchCategory"
          @change="search=''"
           item-text="text"
          item-value="value"
        
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-text-field
        :disabled="!searchCategory"
        v-model="search"
        label="Search"
          class="ma-2"
        single-line
        hide-details
        v-if="searchCategory != 'daily_closing_date'"
      >
      </v-text-field>
      <v-menu
        ref="menuPickDate"
        v-model="menuPickDate"
        :close-on-content-click="false"
        :return-value.sync="search"
        transition="scale-transition"
        offset-y
        min-width="auto"
        v-if="searchCategory == 'daily_closing_date'"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="search"
            label="Picker in menu"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
            class="ma-2"
          single-line
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="search"
          no-title
          scrollable
          range
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menuPickDate = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menuPickDate.save(search)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>



        <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
    </div>
    </v-card-title>
    <!-- <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100, -1]}"
      :options="{'itemsPerPage':50}"
    > -->
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      
      :loading="loadTable"
      loading-text="Loading... Please wait"
      @current-items="getFiltered"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :options.sync="options"
      :server-items-length="totalDataTable"
      :page="page"
      :pageCount="numberOfPages"
      single-expand
      show-expand
      :footer-props="{'items-per-page-options':[5,15, 30, 50, 100]}"
    >

    <template  v-slot:expanded-item="{ headers, item }">
      <td class="pa-5" :colspan="headers.length">
      <!-- Faktur are closed: -->
        <md-table class="ma-5">
          <md-table-row >
            <md-table-head style="text-align: center;"><b>No</b></md-table-head>
            <md-table-head style="text-align: center;"><b>Faktur No</b></md-table-head>
            <md-table-head style="text-align: center;"><b>Amount</b></md-table-head>
          </md-table-row>
          <md-table-row  v-for="(items, index)  in item.faktur_daily_closed" :key="index">
            <md-table-cell style="text-align: center;">{{ index+1 }}</md-table-cell>
            <md-table-cell style="text-align: center;">
              <router-link :to="{name: 'Detail Faktur', params: { id: items.id }}" class="btn btn-primary">
                {{items.faktur_no}}
              </router-link>
            </md-table-cell>
            <md-table-cell style="text-align: center;">Rp. {{ formatPrice( items.faktur_total_biaya_jasa + items.faktur_total_biaya_spare_part + items.faktur_materai + items.faktur_ppn ) }}</md-table-cell>
          </md-table-row>
        </md-table>
      </td>
    </template>
    
    
    
    </v-data-table>
    
  </v-card>
    </template>
  </resizable-page>
  
  </v-app>
</div>
</template>


<script>
import vuetify from '@/plugins/vuetify'
import JsonExcel from "vue-json-excel";
import { ResizablePage } from "@/components";

  export default {
    components: {
    downloadExcel: JsonExcel,ResizablePage
  },
    vuetify,
    data () {
      return {
        mounted:true,
        
        menuPickDate:false,
       
        searchValue:null,
        searchCategory:null,
        option_filter: [ { text: 'Closing Date', value: 'daily_closing_date' },
          { text: 'Remark', value: 'daily_closing_remark'}],
        page: 1,
        totalDataTable: 0,
        numberOfPages: 0,
        loadTable: false,
        role: "",
        search: '',
        options: {},
        headers: [
          // {
          //   text: 'Detail',
          //   align: 'start center',
          //   value: 'detail',
          //   sortable: false
          // },
          { text: 'Closing Date', value: 'daily_closing_date' },
          { text: 'Remark', value: 'daily_closing_remark'},
          { text: 'Detail', value: 'data-table-expand' }

        ],
        table: [],
        worksheetName: "Daily Closings",
        fileName:"Daily Closings.xls",
        exportDisplayedPage:[],
        exportAllFitered:[],
        exportAll:[],
        field_export: {
               no: 'no',
              daily_closing_date : 'daily_closing_date',
              daily_closing_remark : 'daily_closing_remark',
              created_at: 'created_at',
              updated_at: 'updated_at',
              no_faktur : 'no_faktur',
              faktur_no : 'faktur_no',
              faktur_invoice_datetime : 'faktur_invoice_datetime',
              faktur_total_biaya_jasa : 'faktur_total_biaya_jasa',
              faktur_total_biaya_spare_part : 'faktur_total_biaya_spare_part',
              faktur_materai : 'faktur_materai',
              faktur_ppn : 'faktur_ppn'
              

          
        },
      }
    },
    watch: {
    options: {
      handler() {
        if( !this.mounted){
          this.getList();
        }
      },
    },
    deep: true,
  },
    async mounted() {
      //get list role dan permission current user 
      this.role = await this.$store.getters["role_permission/route_filter"];
      
    this.getList();
    this.mounted = false
    },
     methods: {

       formatPrice(value) {
        let val = (value/1).toFixed().replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
       // ambil data yang dibutuhkan

       
    async getList() {
      this.loadTable= true
      const { page, itemsPerPage,sortBy,sortDesc } = this.options;
      console.log(this.options)
      let pageNumber = page;
      
      
      var query = {"page":{number:pageNumber,size:itemsPerPage}}

      if(sortBy.length!=0){
        var  sort=sortBy[0]
        if(sortDesc[0]){
          sort="-"+sortBy[0]
        }
        query.sort = sort
      }

      if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }

      
    
      await this.$store.dispatch("workshop_daily_closing/list",query);
      // if (
      //   (await this.$store.getters["role/list"]) &&
      //   (await this.$store.getters["role/list"].length) != 0
      // ) {
        this.table = await this.$store.getters["workshop_daily_closing/list"];
        var pageMeta  = await this.$store.getters["workshop_daily_closing/page"];
      // }
      // else{
      //   this.table = []
      // }
      console.log(pageMeta)
      this.totalDataTable = pageMeta.total
      this.numberOfPages = pageMeta['to']
      this.loadTable= false
    },
    searchButton(){
       this.options.page = 1;
      this.searchValue = this.search
      this.getList()
    },
    clearSearchButton(){
       this.options.page = 1;
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.getList()
    },

  

    getFiltered(data){
    this.exportDisplayedPage = this.dataExport(data)
    // if(this.$refs.vTable){
    //   this.exportAllFitered = this.dataExport(this.$refs.vTable.$children[0].filteredItems)
    // }
    // else{
    //   this.exportAllFitered = this.dataExport(this.table)
    // }
    },

    //fungsi untuk pinda ke page tambah
    addData() {
      // panggil page add data
      this.$router.push({ name: "Add Daily Closing" });
    },
    async dataExportBefore(type){
      if(this.table.length!=0){
        
     
        if(type=="all"){
          await this.$store.dispatch("workshop_daily_closing/list");
          return this.dataExport(await this.$store.getters["workshop_daily_closing/list"]);
        }
        else if(type=="filter"){

          var query = {}

            // if(sortBy.length!=0){
            //   var  sort=sortBy[0]
            //   if(sortDesc[0]){
            //     sort="-"+sortBy[0]
            //   }
            //   query.sort = sort
            // }

            if(this.searchValue && this.searchCategory){
        
        if(query.filter){
          Object.assign(query.filter, {[this.searchCategory]:this.searchValue});
        }
        else{
          query.filter = {[this.searchCategory]:this.searchValue}
        }
      }

            
          
            await this.$store.dispatch("workshop_daily_closing/list",query);
             return this.dataExport(await this.$store.getters["workshop_daily_closing/list"]);
        }
      }
      
    },
     dataExport(data){
       var dataReturn=[]
        data.forEach((value_1, index_1) => {


        if(value_1.faktur_daily_closed && value_1.faktur_daily_closed.length!=0){
          for (let i = 0;  i < value_1.faktur_daily_closed.length; i++) {
            var data= {
              no:  dataReturn[index_1] && dataReturn[index_1].no == index_1+1 ? null : index_1+1,
              daily_closing_date: value_1.daily_closing_date,
              daily_closing_remark: value_1.daily_closing_remark,
              created_at:  value_1.created_at,
              updated_at:  value_1.created_at,
              no_faktur: value_1.faktur_daily_closed[i]? i+1 : null,
              faktur_no: value_1.faktur_daily_closed[i]? value_1.faktur_daily_closed[i].faktur_no : null,
              faktur_invoice_datetime: value_1.faktur_daily_closed[i]? value_1.faktur_daily_closed[i].faktur_invoice_datetime : null,
              faktur_total_biaya_jasa: value_1.faktur_daily_closed[i]? value_1.faktur_daily_closed[i].faktur_total_biaya_jasa : null,
              faktur_total_biaya_spare_part: value_1.faktur_daily_closed[i]? value_1.faktur_daily_closed[i].faktur_total_biaya_spare_part : null,
              faktur_materai: value_1.faktur_daily_closed[i]? value_1.faktur_daily_closed[i].faktur_materai : null,
            
            }
            dataReturn.push(data)
          } 
        }
        else{
          var data= {
              no:  index_1+1,
              daily_closing_date: value_1.daily_closing_date,
              daily_closing_remark: value_1.daily_closing_remark,
              created_at:  value_1.created_at,
              updated_at:  value_1.created_at,
              no_faktur: null,
              faktur_no: null,
              faktur_invoice_datetime: null,
              faktur_total_biaya_jasa: null,
              faktur_total_biaya_spare_part: null,
              faktur_materai:  null,
              faktur_ppn:  null,
            }
            dataReturn.push(data)
        }

        });
       return dataReturn
      
     
      
    },
      // export_type(type,item){
        
      // }
     },
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
</style>